import { UHCIconImageProps } from './IconImage';
import { Image, Type } from './IconImage.model'
import { IconImageConfig, iconImageConfig } from './IconImage.config'

export function getNameLoweCase(
    image: Image,
    showIconSo: UHCIconImageProps['showIconSo'],
    shortname: UHCIconImageProps['shortname']
    ): string {
        let nameForUrl = !image ? shortname : (image.type === Type.APP && !showIconSo) ? image.application.shortName : image.operationalSystem.shortName;
        return nameForUrl.toLocaleLowerCase().replace(/\s/g, '');
}

export function getIcon(
    image: UHCIconImageProps['image'],
    color: UHCIconImageProps['color'],
    showIconSo: UHCIconImageProps['showIconSo'],
    shortname: UHCIconImageProps['shortname']
): IconImageConfig['png'] | IconImageConfig['pngGrey'] {
    const nameImage = getNameLoweCase(image, showIconSo, shortname);
    let imageUrl: IconImageConfig['png'] | IconImageConfig['pngGrey'];

    iconImageConfig.forEach(element => {
        if (element.shortName.toLocaleLowerCase() === nameImage.toLocaleLowerCase()) {
            if (color) {
                imageUrl = element.png
            } else {
                imageUrl = element.pngGrey
            }
        }
    });
    return imageUrl;
}

export function getSizeClass(size: 0 | 1): string {
    return `size-${size}`;
}